import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase";

Vue.config.productionTip = false
const firebaseConfig = {
  apiKey: "AIzaSyA-9XXtGuNdhMr4sBmO1kUnkAvCZBRIHt8",
  authDomain: "x-m-works.firebaseapp.com",
  databaseURL: "https://x-m-works.firebaseio.com",
  projectId: "x-m-works",
  storageBucket: "x-m-works.appspot.com",
  messagingSenderId: "545995409500",
  appId: "1:545995409500:web:8fc36447d4203866307e99",
  measurementId: "G-L70XEHCE10"
};


import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
  moment,
})

firebase.initializeApp(firebaseConfig);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')